import TurndownService from "turndown";

const USEFUL_HTML = /<(p|div|h[1-6]|ul|ol|li|table|br|span|b|strong|em|i)[\s>]/i;

function createTurndown() {
  const service = new TurndownService({
    headingStyle: "atx",
    bulletListMarker: "-",
    codeBlockStyle: "fenced",
  });
  service.remove(["script", "style"]);
  service.addRule("skipImages", {
    filter: "img",
    replacement() {
      return "";
    },
  });
  return service;
}

function tightenLists(markdown) {
  return String(markdown ?? "").replace(/^(\s*)- {2,}/gm, "$1- ");
}

export function hasUsefulHtml(html) {
  return USEFUL_HTML.test(String(html ?? ""));
}

export function normalizePastedText(text) {
  return String(text ?? "")
    .replace(/\r\n/g, "\n")
    .split("\n")
    .map((line) => {
      const indent = (line.match(/^[\t ]*/) || [""])[0];
      const rest = line.slice(indent.length);
      if (/^[☐]\s+/.test(rest)) {
        return `${indent}- [ ] ${rest.replace(/^[☐]\s+/, "")}`;
      }
      if (/^[☑]\s+/.test(rest) || (/^[✓✔]\s+/.test(rest) && !/^[✓✔]\s*[•●◦]/.test(rest))) {
        return `${indent}- [x] ${rest.replace(/^[☑✓✔]\s+/, "")}`;
      }
      if (/^[•●◦]\s*[✓✔]\s+/.test(rest)) {
        return `${indent}- [x] ${rest.replace(/^[•●◦]\s*[✓✔]\s+/, "")}`;
      }
      if (/^[•●◦]\s+/.test(rest)) {
        return `${indent}- ${rest.replace(/^[•●◦]\s+/, "")}`;
      }
      return line;
    })
    .join("\n");
}

export function htmlToMarkdown(html) {
  const source = String(html ?? "").trim();
  if (!source) return "";
  return tightenLists(normalizePastedText(createTurndown().turndown(source))).replace(
    /^\n+|\n+$/g,
    ""
  );
}

export function pastedMarkdown({ html, text } = {}) {
  const rawHtml = String(html ?? "");
  if (hasUsefulHtml(rawHtml)) {
    const converted = htmlToMarkdown(rawHtml);
    if (converted) return converted;
  }
  return normalizePastedText(text);
}
